import { render, staticRenderFns } from "./SampleInjectionMiniComponent.vue?vue&type=template&id=684f8c5e&scoped=true&"
import script from "./SampleInjectionMiniComponent.vue?vue&type=script&lang=js&"
export * from "./SampleInjectionMiniComponent.vue?vue&type=script&lang=js&"
import style0 from "./SampleInjectionMiniComponent.vue?vue&type=style&index=0&id=684f8c5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684f8c5e",
  null
  
)

export default component.exports